import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { Subject, fromEvent, takeUntil } from 'rxjs';

@Component({
  selector: 'app-input-text-area',
  templateUrl: './input-text-area.component.html',
  styleUrls: ['./input-text-area.component.scss']
})
export class InputTextAreaComponent {
  @Input() label?: string;
  @Input() isRequired = false;
  @Input() value: string = '';
  @Input() errors?: ValidationErrors | null;

  get errorOutput(): string[] {
    const res: string[] = [];
    if (!this.errors) return res;

    for (const k in this.errors) {
      if (Object.prototype.hasOwnProperty.call(this.errors, k)) {
        const element = this.errors[k];
        if (!!element) res.push(k === 'message' ? element : k);
      }
    }

    return res;
  }
}
